import { INichesItems, ICreatorsItems, ITagsList } from "@/common/services/types";
import { SearchCard } from "../SearchCard";
import { SearchResultItem } from "../SearchResultItem";
import { searchTabsEnum } from "../Tabs";
import "./SearchResults.scss";

type TSearchResults = INichesItems | ICreatorsItems | ITagsList;

interface ISearchResults {
  title?: string;
  data: TSearchResults[];
  searchValue?: string;
  activeTab?: Exclude<searchTabsEnum, searchTabsEnum.ALL>;
}

export const SearchResults = ({
  title,
  data,
  searchValue,
  activeTab
}: ISearchResults) => {
  return (
    <div className="searchResults">
      {title && (
        <div className="searchResultsHeader">
          <h4 className="title">{title}</h4>
        </div>
      )}
      <div className="searchResultsList">
        {data.length ? data.map((item: TSearchResults, index: number) => (
          <SearchCard key={index}>
            <SearchResultItem data={item} searchValue={searchValue} />
          </SearchCard>
        )) : <p className="noResults">No results for {activeTab}.</p>}
      </div>
    </div>
  );
};

